module.exports = __webpack_public_path__ + "static/matbuu-detail2-dc4f97bf5bfc6b3cc753418ca4783ac2.png";